import isbot from 'isbot';
import qs from 'qs';

import { priceWithCommas } from '../../utils/commonHelper';
import { addNumberDelimiterForPrice } from '../../utils/stringUtil';
import {
  getYadoBackendHost,
  getSearchParams,
  validateSearchParams,
  reloadPageWithoutSearchParams,
  getResortCode,
  removeShadowGlobalHeader,
  countStayDays,
} from '../helper/accommodation_helper';
import ApiClient from './api_client/accommodation_api_client';
import { trackResortPageEmptyYadoListShown } from '../../trackings/trackResortPageEmptyYadoListShown';
import { setupSearchForm } from './search_form';
import { ICurrency } from '../../ShoppingCart/types';

// 一覧取得の場合、gonにyadoIds（[jxxxxxx, jyyyyyy, ...]）が必要
export function initAccommodationList() {
  removeShadowGlobalHeader();
  setupSearchForm(onClickSearchButton);
  searchPrices();
}

function onClickSearchButton() {
  showLoadingModal();
  searchPrices();
  scrollToAccommodationItems();
  const searchParams = getSearchParams();
}

function searchPrices() {
  const gon = (window as any).gon;
  const ua = (navigator as any).userAgent;

  const apiClient = new ApiClient({ host: getYadoBackendHost() });
  const searchParams = getSearchParams();

  if (!validateSearchParams(searchParams)) {
    reloadPageWithoutSearchParams();
    return;
  }

  displayLoadingPrice();
  rewriteUrls();

  const yadoIds = gon.yadoIds;
  if (yadoIds != null && yadoIds.length >= 1 && !isbot(ua)) {
    apiClient.fetchYadoListPrices(searchParams, yadoIds, onCompletedFetchYadoListPrices);
  }
  if (yadoIds != null && yadoIds.length === 0) {
    // 宿一覧ページで宿が0件（空）の場合トラッキング
    trackResortPageEmptyYadoListShown();
  }
}

function onCompletedFetchYadoListPrices(data: any, yadoIds: Array<string>) {
  let soldoutYadoIds = [].concat(yadoIds);
  if (data && data.yados) {
    hideLoadingModal();
    data.yados.forEach((yado) => {
      displayPrice(yado);
      soldoutYadoIds = soldoutYadoIds.filter(yadoId => yadoId !== yado.id);
    });
    soldoutYadoIds.forEach((yadoId) => {
      displaySoldout(yadoId);
    });
    trackStockFetched(data.yados, soldoutYadoIds);
  }
}

function trackStockFetched(yados, soldoutYadoIds) {
  const $ = (window as any).jQuery;

  const form = $('#accommodations-search-form');
  const paramsString = form.serialize();
  const searchParams = qs.parse(paramsString);
  const stockCount = yados.length;
  const hasStockYadoIds = yados.map(y => y.id);
  const lowestPrices = yados.map(y => y.lowestPrice);
}

function scrollToAccommodationItems() {
  const $ = (window as any).jQuery;

  $('html, body').animate({
    scrollTop: $("#accommodations-search-form").offset().top,
  }, 500);
}

function rewriteUrls() {
  const $ = (window as any).jQuery;

  const linkElems = $(`.accommodation-url`);
  const searchParams = getSearchParams();

  if (searchParams['resort_code'] == null) {
    searchParams['resort_code'] = getResortCode(location.href);
  }
  const queryString = qs.stringify(searchParams);

  linkElems.each((index, elem) => {
    const oldLink = $(elem).attr('href');
    const newLink = oldLink.replace(/\?.+/, `?${queryString}`);
    $(elem).attr('href', newLink);
  });
}

function displayPrice(yado) {
  const $ = (window as any).jQuery;

  const priceElem = $(`#${yado.id}-price`);
  const exchangeRate = Number($('#current-exchange-rate').val());
  const localCurrency :ICurrency = JSON.parse($('#local-currency').val());

  const price =`${localCurrency.code} ${priceWithCommas(yado.lowestPrice * exchangeRate)} (JPY ${addNumberDelimiterForPrice(yado.lowestPrice)})`;

  priceElem.text(price);
}

function displaySoldout(yadoId) {
  const $ = (window as any).jQuery;

  const priceElem = $(`#${yadoId}-price`);

  priceElem.text('Sold Out');
}

function displayLoadingPrice() {
  const $ = (window as any).jQuery;

  const priceElem = $('.hotel_price');
  priceElem.html('<span class="text-primary">loading</span><i class="fas fa-spinner fa-xs fa-pulse fix-spin fa-fw text-primary"></i>');
}

function showLoadingModal() {
  const $ = (window as any).jQuery;
  $("#loading_spinner").show();
  $("#loading_spinner").modal({
    keyboard: false,
    show: true,
  });
}

function hideLoadingModal() {
  const $ = (window as any).jQuery;

  $('body').removeClass('modal-open');
  $('body').css('padding-right', '');
  $("#loading_spinner").hide();
}
